<template>
 <b-overlay :show="showoverlay" rounded="sm">
    <div>
        <div class="clearfix row bg-white mb-4 p-4">
            <div class="col-md-12 px-0">
                <template  v-if="$atl_company_package_title != 'Provident Fund Only'">
                    <h2 class="text-center mb-3">Pay Run Wizard</h2>
                </template>
                <template v-else>
                    <h2 class="text-center mb-3">Provident Fund Run Wizard</h2>
                </template>
                <div class="process-flow mt-5 d-none">                
                    <h6>Process Flow</h6>
                    <div class="row">
                        <div class="rounded process-flow-charts d-flex align-items-center justify-content-center py-4 card"><div class="process-flow-inner"><span><img v-bind:src="$api_url+'/images/Fiscal-Year.png'"  class="img-fluid mr-3" height="40px" width="40px" /></span><span>Choose<br/>Period</span></div></div>
                        <div class=" rounded process-flow-charts d-flex align-items-center justify-content-center py-4 card col-half-offset"><div class="process-flow-inner"><span><img v-bind:src="$api_url+'/images/New-Joiner.png'"  class="img-fluid mr-3" height="40px" width="40px" /></span><span>Add<br/>Joiners</span></div></div>
                        <div class=" rounded process-flow-charts d-flex align-items-center justify-content-center py-4 card col-half-offset"><div class="process-flow-inner"><span><img v-bind:src="$api_url+'/images/Contract-Changes.png'"  class="img-fluid mr-3" height="40px" width="40px" /></span><span>Update<br/>Contracts</span></div></div>
                        <div class=" rounded process-flow-charts d-flex align-items-center justify-content-center py-4 card col-half-offset"><div class="process-flow-inner"><span><img v-bind:src="$api_url+'/images/Leavers.png'"  class="img-fluid mr-3" height="40px" width="40px" /></span><span>Process<br/>Leavers</span></div></div>
                        <template  v-if="$atl_company_package_title != 'Provident Fund Only'">
                            <div class=" rounded process-flow-charts d-flex align-items-center justify-content-center py-4 card col-half-offset"><div class="process-flow-inner"><span><img v-bind:src="$api_url+'/images/General-Payrun.png'"  class="img-fluid mr-3" height="40px" width="40px" /></span><span>Run<br/>Payroll</span></div></div>
                        </template>
                        <template  v-else>
                            <div class=" rounded process-flow-charts d-flex align-items-center justify-content-center py-4 card col-half-offset"><div class="process-flow-inner"><span><img v-bind:src="$api_url+'/images/General-Payrun.png'"  class="img-fluid mr-3" height="40px" width="40px" /></span><span>Run<br/>PF Cycle</span></div></div>
                        </template>
                        
                        <div class=" rounded process-flow-charts d-flex align-items-center justify-content-center py-4 card col-half-offset"><div class="process-flow-inner"><span><img v-bind:src="$api_url+'/images/payroll-success.png'"  class="img-fluid mr-3" height="40px" width="40px" /></span><span>Success</span></div></div> <!--aboni-->
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 bg-white shadow-lg payrun-wizard-container">
            <form-wizard ref="wizard" color="#43A047" @on-complete="onComplete">
                <h2 class="py-2 mt-3 mb-4 d-none" slot="title">Payrun Wizard</h2> 
                <tab-content title="Choose Period" :before-change="changeMessageflag" :after-change="changeMessageflag">                    
                    
                     
                     <payrun-wizard :pageurl="this.$api_url" company_name="" :current_fiscal_year="fiscal_year" :current_month="fiscal_month" v-on:childToParent="ReceivedfromChild" :key="componentKey"></payrun-wizard>
                    
                    <div  class="clearfix row mt-4 form-btn-container">
                        <div class="col-md-6 pl-0"> </div>
                        <div class="col-md-6 pr-0 text-right"><b-button type="button" variant="primary" @click="moveNext('fiscal_year')">Next</b-button></div>
                    </div>
                </tab-content>

                <tab-content title="Add Joiners" lazy=true  :before-change="changeMessageflag" :after-change="changeMessageflag">
                    <div class="card " v-if="xdata.new_joiner_has">
                        <div class="card-body py-0">
                            <div class="justify-content-center py-2 mb-3 border-bottom mx-n-custom"><div class="col-sm-6 px-3 company-form-box-title">Add Joiners</div></div>
                            <div class="deprtment-top-block border mt-4 mb-5 p-5">
                                <h6  style='font-size:24px;' class="mb-4">Do you have any joiner(s) this month?</h6>
                                <b-button class="yes-btn mr-2 w-auto px-4" type="button" variant="primary" @click="showHideBlock('show_new_joiner_options' , 'new_joiner_has')">Yes</b-button>
                                <b-button class="ml-2 w-auto px-4" type="button" variant="primary" @click="moveNext('joiner')">No</b-button>
                                <b-button class="ml-2 w-auto px-4" type="button" variant="primary" @click="moveNext('joiner')">Already Added</b-button>
                            </div>
                        </div>
                    </div>

                    <div class=" " v-if="xdata.show_new_joiner_options">
                        <div class="row clearfix text-center" v-if="new_employee_created">
                            <div class="col-md-12"><h2>New employee has been created!</h2></div>
                            <div class="col-md-12">You can update the employee info below or 
                                <b-button class="ml-2 w-auto px-4" type="button" variant="primary" @click="flushEmployee()">Create New Employee</b-button> <span>or</span> <b-button class="ml-2 w-auto px-4" type="button" variant="primary" @click="moveNext('joiner')">Move to Next Step</b-button>
                            </div>
                        </div>
                        
                        <div class="row clearfix"><div class="col-md-12">Add Joiners</div></div>
                        <div class=" ">
                            <account-employees :pageurl="this.$api_url" :key="this.x" v-on:childToParent="getAccountEmployees"></account-employees>
                        </div>

                        <div class="clearfix row mt-4 form-btn-container">
                            <div class="col-md-6 pl-0"><b-button type="button" variant="primary" @click="flushEmployee()">Add New Employee</b-button></div>
                            <div class="col-md-6 pr-0 text-right"><b-button type="button" variant="primary" @click="moveNext('joiner')">Move Next</b-button></div>
                        </div>
                    </div>
                    
                    <div class="clearfix row mt-4 form-btn-container">
                            <div class="col-md-6 pl-0"><b-button type="button" variant="primary"  @click="moveBack()">Back</b-button></div>
                            <div class="col-md-6 pr-0 text-right"><!--<b-button type="button" variant="primary" @click="moveNext('joiner')">Move Next</b-button>--></div>
                    </div>
                    
                </tab-content>
                <tab-content title="Update Contracts" :before-change="changeMessageflag" :after-change="changeMessageflag">
                   
                   <div class="card " v-if="xdata.contract_has">
                        <div class="card-body py-0">
                            <div class="justify-content-center py-2 mb-3 border-bottom mx-n-custom"><div class="col-sm-6 px-3 company-form-box-title">Update Contracts</div></div>
                            <div class="deprtment-top-block border mt-4 mb-5 p-5">
                                <h6 class="mb-4"  style='font-size:24px;'>Do you have any Contract Changes in this Month?</h6>
                                <b-button class="yes-btn mr-2 w-auto px-4" type="button" variant="primary" @click="showHideBlock('show_contract_options' , 'contract_has')">Yes</b-button>
                                <b-button class="ml-2 w-auto px-4" type="button" variant="primary" @click="moveNext('contract')">No</b-button>
                            </div>
                        </div>
                    </div>

                    <div class=" " v-if="xdata.show_contract_options">
                        <div class="justify-content-center py-2 mb-3 border-bottom"><div class="col-sm-6 company-form-box-title pl-0">Update Contracts</div></div>
                        <div class=" ">
                            <contract-payroll-wizard :pageurl="this.$api_url" :company_id="this.company_id"></contract-payroll-wizard>
                        </div>

                        <div class="clearfix row mt-4 form-btn-container">
                            <div class="col-md-6 pl-0"><b-button type="button" variant="primary"  @click="moveBack()">Back</b-button></div>
                            <div class="col-md-6 pr-0 text-right"><b-button type="button" variant="primary" @click="moveNext('contract')">Move Next</b-button></div>
                        </div>
                    </div>
                    <div class="clearfix row mt-4 form-btn-container" v-else>
                            <div class="col-md-6 pl-0"><b-button type="button" variant="primary"  @click="moveBack()">Back</b-button></div>
                            <div class="col-md-6 pr-0 text-right"><!--<b-button type="button" variant="primary" @click="moveNext('contract')">Move Next</b-button>--></div>
                    </div>
                </tab-content>

                <tab-content title="Process Leavers"  :before-change="changeMessageflag" :after-change="changeMessageflag">
                    <div class="card " v-if="xdata.leaver_has">
                        <div class="card-body py-0">
                            <div class="justify-content-center py-2 mb-3 border-bottom mx-n-custom"><div class="col-sm-6 px-3 company-form-box-title">Process Leavers</div></div>
                            <div class="deprtment-top-block border mt-4 mb-5 p-5">
                                <h6 class="mb-4"  style='font-size:24px;'>Do you have any Leavers in this Month?</h6>
                                <b-button class="yes-btn mr-2 w-auto px-4" type="button" variant="primary" @click="showHideBlock('show_leaver_options' , 'leaver_has')">Yes</b-button>
                                <b-button class="ml-2 w-auto px-4" type="button" variant="primary" @click="moveNext('leaver')">No</b-button>
                            </div>
                        </div>
                    </div>

                    <div class=" " v-if="xdata.show_leaver_options">
                        <div class="justify-content-center py-2 mb-3 border-bottom"><div class="col-sm-6 company-form-box-title pl-0">Process Leavers</div></div>
                        <div class=" ">
                            <leaver-wizard :pageurl="this.$api_url" :company_id="this.company_id" :key="'leaver'+componentKey" :current_fiscal_year="fiscal_year" :current_month="fiscal_month"></leaver-wizard>
                        </div>

                        <div class="clearfix row mt-4 form-btn-container">
                            <div class="col-md-6 pl-0"><b-button type="button" variant="primary"  @click="moveBack()">Back</b-button></div>
                            <div class="col-md-6 pr-0 text-right"><b-button type="button" variant="primary" @click="moveNext('leaver')">Move Next</b-button></div>
                        </div>
                    </div>
                    <div class="clearfix row mt-4 form-btn-container" v-else>
                            <div class="col-md-6 pl-0"><b-button type="button" variant="primary"  @click="moveBack()">Back</b-button></div>
                            <div class="col-md-6 pr-0 text-right"><!--<b-button type="button" variant="primary" @click="moveNext('leaver')">Move Next</b-button>--></div>
                    </div>
                </tab-content>

                <tab-content :title="run_payroll_title" :before-change="beforeTabSwitch" :after-change="changeMessageflag">
                  
                  <div class="card ">
                        <div class="card-body py-0">
                            
                            <template  v-if="$atl_company_package_title != 'Provident Fund Only'">
                                <div class="justify-content-center py-2 mb-3 border-bottom mx-n-custom"><div class="col-sm-6 px-3 company-form-box-title">Run Payroll</div></div>
                            </template>
                            <template  v-else>
                               <div class="justify-content-center py-2 mb-3 border-bottom mx-n-custom"><div class="col-sm-6 px-3 company-form-box-title">Run Provident Fund</div></div>
                            </template>
                        
                            <div class="deprtment-top-block border mt-4 mb-5 pt-5 position-relative px-0" style="min-height: 445px;">
                                
                                <template  v-if="$atl_company_package_title != 'Provident Fund Only'">
                                    <h6 class="mb-4" style='font-size:24px;'>Ready to Run the Following Payroll?</h6>
                                </template>
                                <template v-else>
                                    <h6 class="mb-4" style='font-size:24px;'>Ready to Run the Following Provident Fund ?</h6>
                                </template>
                                <div v-if="success != '' && success !='Payrun Created Successfully!'  && success !='Payrun Updated Successfully!' && success !='Provident Fund Created Successfully!' && success !='Provident Fund Run Updated Successfully!'" class="alert alert-danger" role="alert"> {{success}} </div>
                                <h4 class="mb-4">Fiscal Year: {{fiscal_year}}</h4>
                                <h4 class="mb-4">Month: {{fiscal_month_name}} {{year_segment}}</h4>
                                
                                <template  v-if="$atl_company_package_title != 'Provident Fund Only'">
                                    <h5 style="font-weight: normal;font-size: 16px;" class="mb-4">Hold tight there, we will process {{number_of_employees}} payslips for this payrun!</h5>
                                </template>
                                <template v-else>
                                    <h5 style="font-weight: normal;font-size: 16px;" class="mb-4">Hold tight there, we will process {{number_of_employees}} entries for this Provident Fund Run!</h5>
                                </template>

                                <template  v-if="$atl_company_package_title != 'Provident Fund Only'">
                                    <button v-if="success == ''" type="button" style="width: 300px !important;" class="btn yes-btn mr-8 w-auto px-8 btn-primary mb-5" @click="executePayrun()">Run Regular Payroll</button>
                                    <button v-if="success == ''" type="button" style="width: 300px !important;" class="btn yes-btn mr-8 w-auto px-8 btn-primary mb-5" @click="executePayrunManual()" title="System will generate blank payslips only. You will need manually import payroll data." v-b-tooltip.top.hover="{ customClass: '' }">Run Manual Payroll</button>
                                    <button v-if="success != '' && success !='Payrun Created Successfully!'  && success !='Payrun Updated Successfully!' && success !='Provident Fund Created Successfully!' && success !='Provident Fund Run Updated Successfully!' " type="button" style="width: 300px !important;" class="btn yes-btn mr-8 w-auto px-8 btn-primary mb-5" @click="moveToFiscalYear()">Go Back To Select Fiscal Year</button>
                                    <div class="col-md-12 pay-run-loader overflow-hidden" v-if="loading != ''">
                                        <h6 style="color: #fff;">{{fiscal_month_name}} - {{year_segment}}</h6>
                                        <p style="color: #fff;">Alright world, time to take you on!<br/>Payrun calculations in progress ...</p>
                                        <img :src="$api_url+'/images/loading.gif'" width="40">
                                        <div class="loading-stroke"></div>
                                        <b-progress :max="number_of_employees" class="payroll-progress" show-progress animated>
                                            <b-progress-bar :value="progress_value" :label="(progress_value)+' / '+(number_of_employees)"></b-progress-bar>
                                        </b-progress>
                                    </div>
                                </template>
                                <template v-else>
                                    <button v-if="success == ''" type="button" style="width: 300px !important;" class="btn yes-btn mr-8 w-auto px-8 btn-primary mb-5" @click="executePayrun()">Run Provident Fund</button>
                                    
                                    <button v-if="success != '' && success !='Payrun Created Successfully!'  && success !='Payrun Updated Successfully!'  && success !='Provident Fund Created Successfully!' && success !='Provident Fund Run Updated Successfully!'" type="button" style="width: 300px !important;" class="btn yes-btn mr-8 w-auto px-8 btn-primary mb-5" @click="moveToFiscalYear()">Go Back To Select Fiscal Year</button>
                                    <div class="col-md-12 pay-run-loader overflow-hidden" v-if="loading != ''">
                                        <h6 class="font-semi-bold mt-5" style="font-size:24px; color: #0060C9;">{{fiscal_month_name}} {{year_segment}} - Monthly Payrun</h6>
                                        <p style="color: #01524B; margin-bottom: 0;">Provident Fund calculations in progress ...</p>
                                        <img :src="$api_url+'/images/payrun-loader.png'" width="85" class="loader-logo">
                                        <div class="loading-stroke d-none"></div>
                                        <b-progress :max="number_of_employees" class="payroll-progress" show-progress animated>
                                            <b-progress-bar :value="progress_value" :label="(progress_value)+' / '+(number_of_employees)"></b-progress-bar>
                                        </b-progress>
                                    </div>
                                </template>
                                
                            </div>
                        </div>
                        
                    </div>
                    
                    <div  class="clearfix row mt-4 form-btn-container">
                        <div class="col-md-6 pl-0"><b-button type="button" variant="primary" @click="moveBack()">Back</b-button></div>
                        <div class="col-md-6 pr-0 text-right"><!--<b-button type="button" variant="primary" @click="moveNext('payrun')">Next</b-button>--></div>
                    </div>
                </tab-content>

                <tab-content title="Success">
                    <div class="clearfix">
                        <div class="clearfix company-form-container rounded mt-4 pb-5 mx-auto px-3">
                            <div class="clearfix row py-2 mb-2 border-bottom">
                                <div class="col-sm-6 px-3 company-form-box-title">Success</div>
                            </div> 
                            
                            <div class="row px-5 ml-auto mr-auto bg-white mt-4 position-relative" style="width: 90%;" v-if="show_final_message=='yes'">
                                <svg id="m-check-mark" class="custom-success-arrow" width="100px" height="100px" viewBox="0 0 245 173" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-opacity="1">
                                        <polyline id="checkmark" stroke="rgba(67, 160, 71, 1)" stroke-width="15" points="5.640625 83.7607422 83.2539062 161.663086 238.97168 6.11328125"></polyline>
                                    </g>
                                </svg>
                                <svg width="200" height="200" style="background: transparent;" id="custom-success-circle-noanimation" class="ml-auto mr-auto d-block mt-5">
                                    <circle class="outer" cx="100" cy="100" r="85" transform="rotate(-90, 95, 95)"></circle>
                                </svg>
                                <h5 class="text-center w-100 my-3">All Done</h5>
                                
                                <a :href="$api_url+'/provident-fund-runs'" class="btn btn-primary w-100 mb-3">Go to Provident Fund Runs</a>
                                <a :href="$api_url+'/employee'" class="btn btn-primary w-100 mb-4">Go to Employee Management</a>
                            </div>
                            
                            <!-- Draft Payrun Table Starts-->
                            <br />
                           	<div style="text-align: center; width: 100%; margin-bottom: 10px;"><h5>Draft Provident Fund Runs</h5></div>

                            	<table class="table" v-if="pending_payruncount!=0">
                            	  <thead>
                            		
                            	  </thead>
                            	  <tbody>
                                    <tr class="table-head">
                            		  <td>Title</td>
                            		  <td>Fiscal year</td>
                            		  <td>Month</td>
                            		  <td>Employer Contribution</td>
                                      <td>Employee Contribution</td>
                                      <td>Total Contribution</td>
                            		  <td class="text-right">Action</td>
                            		</tr>
                            		<tr class="table-row hover-bg" v-for="prun in payruns" :key="prun.id">
                            		  <td><span v-if="prun.locked!=1"><a :href="pgurl+'/provident-fund-runs-payslips/'+prun.id+''">{{replacePayrun(prun.name)}}</a></span><span v-else>{{replacePayrun(prun.name)}}</span></td>
                            		  <td>{{prun.fiscal_year}}</td>
                            		  <td>{{prun.month}}, {{prun.year}}</td>
                            		  <td style="text-align: right;">{{prun.pf_employer_contribution}}</td>
                                      <td style="text-align: right;">{{prun.pf_employee_contribution}}</td>
                                      <td style="text-align: right;">{{prun.total_pf_contribution}}</td>
                            		  <td class="position-relative text-right">
                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                        <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                            <span v-if="prun.locked!=1"><a class="btn btn-primary" :href="pgurl+'/provident-fund-runs-payslips/'+prun.id+''"><b-icon icon="pencil-square"></b-icon>Review</a></span>
                                            <span v-else><a class="btn btn-primary" @click="showApproveModal(prun.id)"><b-icon icon="check2-circle"></b-icon>Approve</a></span>
                                        </div>
                                      </td>
                            		</tr>
                            	  </tbody>
                            	  <tfoot>
                            		<tr>
                            		  <td colspan="9">
                                                <div class="row p-2 float-right" v-if="pagination.total > 0">  
                                                     <!--<ul class="pagination b-pagination" style="margin-bottom: 0;">
                                                        <li class="page-item disabled m-2">View</li>
                                                        <li class="page-item disabled">
                                                        <b-form-select class="input" type="text" v-model="per_page" @change="setSearch()">
                                                        <option value="5">5</option>
                                                        <option value="10">10</option>
                                                        <option value="20">20</option>
                                                        </b-form-select></li>
                                                        <li class="page-item disabled m-2">per page. Total {{pagination.total}} records found.</li>
                                                     </ul> -->             
                                                    <b-pagination-nav class="float-right" :link-gen="linkGen" v-model="pagination.currentPage" :number-of-pages="pagination_length" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
                                                </div>
                                      
                                      </td>
                            		</tr>
                            	  </tfoot>
                            	</table>
                                
                                <div v-if="pending_payruncount==0">No Pending Payroll Run Found<hr /></div>
                        <!-- Draft Parun Table Ends-->
                            
                        </div>
                    </div>
                </tab-content>


            </form-wizard>
            
        </div>
        
        
             <div><b-modal id="approve-modal" title="Are you sure to Approve?" hide-footer> Please Enter your Password to Continue:
             <br />
             <input id="approvepass" type="password" class="form-control" v-model="approvepass" name="approvepass"> 
            
             <div v-if="incorrectpass != ''" class="alert alert-danger" role="alert" style="clear: both; margin-top: 10px;"> {{incorrectpass}} </div>
             <div style="height: 10px;clear:both;"> &nbsp;</div>
              <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="approvePayrun(approval_payrun_id)">Approve</a>
              &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('approve-modal')">Cancel</a>
              <div style="height: 5px;clear:both;"> &nbsp;</div>
              
              <span v-if="loading != ''"><img :src="pgurl+'/images/loading.gif'" width="30"></span>
             </b-modal>
             </div>
              
              
    </div>
    </b-overlay>
</template>

<script>
    import {FormWizard, TabContent} from 'vue-form-wizard'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'
    

    export default{
        
        mounted() {
            
        },
        props: ['pageurl'],
        components: {
           FormWizard,  TabContent,
        },
        data(){            
            
            return {
                cu:window.location.href,
                ce:false, 
                pageUrl:this.$api_url,
                company_id : 0, // need to fetch company id at the beginning
                completion : 0,
                x : 0,
                new_employee_created : false,
                run_payroll_title:'',
                
                ///////////Payrun
                payruns : [],                
                fiscal_month: null,
                fiscal_year: null,
                fiscal_month_name: null,
                success: '',
                loading:'',
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
                paginationapproved: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
                search:{employee_id:'', pay_slip_name:'', pay_slip_ref:'', fiscal_year:'', month:''},
                pagination_length: 0,
                link_tracker:0,
                approved_pagination_length: 0,
                approved_link_tracker:0,
                per_page:10, 
                per_pageapproved:10,               
                pgurl:this.$api_url,
                company_title: this.company_name,
                cur_fiscal_year: this.current_fiscal_year,
                pending_payruncount:0,
                approved_payruncount:0,
                approvepass: '',
                incorrectpass: '',
                unapproval_payrun_id: '',
                approval_payrun_id:'',
                show_final_message: '',
                payrun_type: 0,
                //////////////
                
                progress_value : 0,
                progress_max : 20,
                number_of_employees : 0,                
                payslip_array : [],
                year_segment:'',
                atl_company_package_title:this.$atl_company_package_title,
                
                componentKey: 0,
                showoverlay: false,
                step_update: false,
                all_steps: ['Fiscal Year','New Joiner','Contract Changes','Leavers','Payrun'],
                xdata : {
                        show_new_joiner_options : false, new_joiner_has : true,  new_joiner_options : false,
                        show_contract_options : false, contract_has : true,  contract_options : false,
                        show_leaver_options : false, leaver_has : true,  leaver_options : false,
                        //show_jobposition_options : false, jobposition_has : true,  jobposition_options : false,
                        //show_branch_options : false, branch_has : true,  branch_options : false,
                    },
                
            }
        },
        methods:{
            
            
            setYearWithMonth: function()
			  {
			     var yr=this.fiscal_year.split("-");
			     var month=this.fiscal_month;
                 if(month > 6)
                 this.year_segment=yr[0];
                 else
                 this.year_segment=yr[1];
                 
              },
            ReceivedfromChild: function(year, month)
            {
                //console.log(year+" Month:"+month); 
                this.fiscal_month =   month;
                this.fiscal_year =   year;
                
                var months = ["", "January", "February", "March", "April", "May", "June", 
           "July", "August", "September", "October", "November", "December" ];
           
                this.fiscal_month_name=months[month];
                      
            },
              countPayslip: function()
              {
                  axios.get(this.$api_url+'/get-pfslip-count?month='+this.fiscal_month+'&fiscalyear='+this.fiscal_year , {
                    params: {
                        
                    }
                  }).then(function(response){
                    //console.log(response.data);
                    this.number_of_employees = response.data;
                    
                  }.bind(this)).catch(function (error){ this.serverError(error);});
                  return true;
              },
            
   			  executePayrun: function(pageflg)
			  {
                
			      let currentObj = this;  
                  currentObj.number_of_employees = 0;
                  currentObj.progress_value = 0;                
                  // Payrun progress bar code start
                  let check_payrun = setInterval(() => {
                      axios.get(this.$api_url+'/get-inactive-payrun-payslips', {
                        params: {
                            
                        }
                      }).then(function(response){
                        //console.log(response.data);
                        if(response.data.payslip_count != 0){
                            currentObj.payslip_array = response.data;
                            
                            for (let [key, value] of Object.entries(currentObj.payslip_array)) 
                            {
                                currentObj.number_of_employees = value.payslip_count;
                                currentObj.progress_value = value.created_payslip_count;
                            }                            
                        }else{
                            clearInterval(check_payrun);
                        }
                        
                      }.bind(this)).catch(function (error){ currentObj.output = error;});
                  }, 3000);
                  // Payrun progress bar code end
  
                  this.loading='load';
  
				  const config = {
  
					  headers: { 'content-type': 'multipart/form-data' }
  
				       }
  
				  let formData = new FormData();
                  
                  var payslip_type='';
                  
                  //if(this.payrun_type==1)
                 // payslip_type='?payslip_type=off_cycle'
  
				  axios.get(this.$api_url+'/salary-slips-company/'+this.fiscal_month+'/'+this.fiscal_year+'/2'+payslip_type+'?flag=1', formData, config)
  
				  .then(function (response) {
                      currentObj.progress_value = currentObj.number_of_employees;
					  currentObj.success = response.data.success;
					  currentObj.payrun_id = response.data.payrun_id;
                      console.log(currentObj.$api_url+'/update-payrun-status/?payrun_id='+currentObj.payrun_id);
                      
                       currentObj.setSearch();
                       currentObj.loading='';
                      
                      if(currentObj.success=="Payrun Created Successfully!" || currentObj.success=="Payrun Updated Successfully!" || currentObj.success=="Provident Fund Created Successfully!" || currentObj.success=="Provident Fund Run Updated Successfully!")
                      {
                        if(currentObj.success=="Payrun Created Successfully!"){
                            axios.get(currentObj.$api_url+'/update-payrun-status/?payrun_id='+currentObj.payrun_id)
                            .then(function (response) {
                                console.log(response.data);
                            })
                            .catch(function (error) {
      
        					   currentObj.output = error;
          
        				    });
                        }
                        currentObj.moveNext('payrun');
                        currentObj.show_final_message='yes';
                        
                       setTimeout(function(){ var cols = document.getElementsByClassName('wizard-progress-bar');
                        var i=0;
                        for(i = 0; i < cols.length; i++) {
                        cols[i].style.cssText  = 'background-color: rgb(67, 160, 71); color: rgb(67, 160, 71); width:100% !important';
                        
                        } }, 800); 
                        
                      }
                     
  
				  })
  
				  .catch(function (error) {
  
					  currentObj.output = error;
  
				  });

                 
 			  },
              
              executePayrunManual() {
  
				  let currentObj = this;
                  currentObj.number_of_employees = 0;
                  currentObj.progress_value = 0;
  
                  this.loading='load';
                                    
                  // Payrun progress bar code start
                  let check_payrun = setInterval(() => {
                      axios.get(this.$api_url+'/get-inactive-payrun-payslips', {
                        params: {
                            
                        }
                      }).then(function(response){
                        //console.log(response.data);
                        if(response.data.payslip_count != 0){
                            currentObj.payslip_array = response.data;
                            
                            for (let [key, value] of Object.entries(currentObj.payslip_array)) 
                            {
                                currentObj.number_of_employees = value.payslip_count;
                                currentObj.progress_value = value.created_payslip_count;
                            }                            
                        }else{
                            clearInterval(check_payrun);
                        }
                        
                      }.bind(this)).catch(function (error){ currentObj.output = error;});
                  }, 3000);
                  // Payrun progress bar code end
  
				  const config = {
  
					  headers: { 'content-type': 'multipart/form-data' }
  
				  }
  
   
  
				  let formData = new FormData();
                  formData.append('year', this.fiscal_year);
                  formData.append('Month', this.fiscal_month);
                  formData.append('payrun_type', 9);
                  

                      var payslip_type='?payslip_type=manual';
      
    				  axios.get(this.$api_url+'/salary-slips-company/'+this.fiscal_month+'/'+this.fiscal_year+'/0'+payslip_type+'&flag=1', formData, config)
      
    				  .then(function (response) {
      
    					  currentObj.success = response.data.success;
                           currentObj.setSearch();
                           currentObj.loading='';
    					   //currentObj.$bvModal.hide('manual_payrun_modal');
                           
                           if(currentObj.success=="Payrun Created Successfully!"){
                               currentObj.moveNext('payrun');
                               currentObj.show_final_message='yes';
                                
                               setTimeout(function(){ var cols = document.getElementsByClassName('wizard-progress-bar');
                                var i=0;
                                for(i = 0; i < cols.length; i++) {
                                cols[i].style.cssText  = 'background-color: rgb(67, 160, 71); color: rgb(67, 160, 71); width:100% !important';
                                
                                } }, 800); 
                            }
      
    				  })
      
    				  .catch(function (error) {
                          //currentObj.$bvModal.hide('manual_payrun_modal');
                          currentObj.error_msg="Operation Failed. "+error;
                          currentObj.loading='';
                          
    					  //currentObj.output = error;
      
    				  });
                 
                  

  
			  },
              
              
              
 			  setSearch: function(pageflg)
			  {
				  this.pagination.currentPage = 1;
				  this.getpayruns();

			  },
			  setPagination: function(pageflg)
			  {                
				  if(pageflg)
					  this.pagination.currentPage = this.pagination.nextPage;
				  else    
					  this.pagination.currentPage = this.pagination.prevPage;
				  
				  this.getpayruns();
			  },
              
              showApproveModal: function(pageflg)
              {
                this.approval_payrun_id=pageflg;
                this.$bvModal.show('approve-modal');
                this.approvepass=''; 
              },

              
 
              approvePayrun: function(pageflg)
			  {
                 if(this.approvepass!='')
                 {
                  var pass=this.approvepass;  
			      this.loading='load';
                                                
				  this.pagination.currentPage = 1;
						  axios.get(this.$api_url+'/payrun-update-status/'+pageflg+'/1', {
							  params: {
								  jsonmode: 'on',
                                  pass: pass,								 
							  }
					  }).then(function(response){
					   
					  //this.fdata.status = response.data.success;
                      if(response.data.success=='1')
                      {
                       this.incorrectpass='';
                       this.$bvModal.hide('approve-modal'); 
                       
                            this.getpayruns();

                      
                      }
                      else
                      {
                        this.incorrectpass="Incorrect Password";
                      }  
                      this.loading='';                      
  
					  
				  }.bind(this));
                  }                  
                  
				 // this.getchallans();
			  },       
              
              
              replacePayrun:function(data)
              {
                 return data.replace('Payroll','Provident Fund');
              },
 			  getpayruns: function()
			  {
  
						  axios.get(this.$api_url+'/list-all-payruns' , {
							  params: {
								  page: this.pagination.currentPage,
								  per_page: this.per_page,
								  search_query: this.search,
								  search_query_by_id: this.search_by_id,
							  }
					  }).then(function(response){
					  this.payruns = response.data.data;
                      this.pending_payruncount=this.payruns.length;
					  this.pagination.from = response.data.from;
					  this.pagination.to = response.data.to;
					  this.pagination.total = response.data.total;
                      
                      if(this.pagination.total>0)
                      {
                        this.pagination_length=Math.ceil((this.pagination.total/this.per_page));
                      }
					  
					  if(this.pagination.to==this.pagination.total)
					  {
						  
						  this.pagination.nextbuttonstatus = 'disabled';
						  
					  }
					  else
					  {
						   this.pagination.nextbuttonstatus = '';
					  }
					  
					  if(this.pagination.from==1)
					  {
					  this.pagination.prebuttonstatus = 'disabled';
					  }
					  else
					  {
						 this.pagination.prebuttonstatus = ''; 
					  }
  
  
  
					  if(this.pagination.currentPage < response.data.last_page)
						  this.pagination.nextPage = this.pagination.currentPage + 1;
  
					  if(this.pagination.currentPage == 1)
						  this.pagination.prevPage = 1;
					  else 
						  this.pagination.prevPage = this.pagination.currentPage - 1;
				  }.bind(this));
			  },  
              
              linkGen: function(pageNum)
			  {
			     if(this.link_tracker!=this.pagination.currentPage)
                 {
                    this.link_tracker=this.pagination.currentPage;
                    this.getpayruns();
                 }
                 
              },

            
            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;                    
                }.bind(this));
            },
            flushEmployee: function()
            {
                this.new_employee_created = false;
                let formData = new FormData();                
                formData.append('sess', 'employee_id');
                axios.post(this.$api_url+'/flushsess', formData)
                                .then(function (response) {
                    this.x += 1; 
                }.bind(this));
            },
            getAccountEmployees (value) 
            {                
                if(value.employee_id > 0)
                {
                    this.new_employee_created = true;
                }                   

            },

            showHideBlock: function(x , y){
                             
                this.xdata[y] = false;
                this.xdata[x] = true;
            },
            
            moveNext: function(curr_step=''){
                
                //if(curr_step!="payrun")
                //this.show_final_message='';
                if(curr_step =='fiscal_year'){
                  if(!this.fiscal_year || !this.fiscal_month){
                     this.$bvToast.toast('Select valid fiscal year and month to continue', {title: 'Error!',variant: 'danger',solid: true});
                  }else{
                    this.updatePayrunProgress(curr_step);
                    this.countPayslip();      
                    this.setYearWithMonth();
                  }  
                }else{
                    this.updatePayrunProgress(curr_step);
                }  
            },
            moveToFiscalYear: function()
            {
                this.$refs.wizard.changeTab(0,0);
                this.success = '';
            },
            moveBack: function(){
                this.$refs.wizard.prevTab();
            },
            moveFinish: function(){
                this.$refs.wizard.activateAll();
                //this.$refs.wizard.nextTab();
                this.$refs.wizard.changeTab(0,4);
                this.onComplete();
            },
            onComplete: function(){
                
                this.$bvToast.toast('Yay. Done!', {
                                            title: `All steps completed`,
                                            variant: 'success',
                                            solid: true
                                        });


                //location.reload(); 
            },
            beforeTabSwitch: function(){
                //this.progress_value = 100;
                let custom_success_circle = document.getElementById('custom-success-circle-noanimation');
                if(custom_success_circle){
                    custom_success_circle.classList.add('custom-success-circle');
                }
                let custom_success_arrow = document.getElementById('m-check-mark');
                if(custom_success_arrow){
                    custom_success_arrow.classList.add('custom-success-arrow-animation');
                }
                
                return true;
            },
            
            
            changeMessageflag: function(){
                this.show_final_message='';
                this.success='';
                return true;
            },
            
            get_selected_year: function(){

              alert(this.$refs.PayrunWizard.year);
            },
            
           resetPayrunProgress: function(upd_step){
             this.showoverlay = true;
             let formData = new FormData();                
             formData.append('step', upd_step);
             formData.append('fiscal_year', this.fiscal_year);
             formData.append('month', this.fiscal_month);
             formData.append('reset_payrun', 1);
             axios.post(this.$api_url+'/update-payrun-step', formData)
                                    .then(function (response) {
                        this.showoverlay = false;
                        this.$refs.wizard.nextTab();
                    }.bind(this));
           },
            
           updatePayrunProgress: function(upd_step)
            {
                if(upd_step){
                    this.showoverlay = true;
                    let formData = new FormData();                
                    formData.append('step', upd_step);
                    formData.append('fiscal_year', this.fiscal_year);
                    formData.append('month', this.fiscal_month);
                    
                    axios.post(this.$api_url+'/update-payrun-step', formData)
                                    .then(function (response) {
                        //this.x += 1; 
                        this.showoverlay = false;
                        if(upd_step =='fiscal_year'){
                          let step_number =  parseInt(response.data.next_step); 
                          let completed =  response.data.completed;
                          if(completed != '1'){
                            if(step_number>1){



                                if(this.atl_company_package_title != 'Provident Fund Only')
                                {
                                    this.$bvModal.msgBoxConfirm('Looks like you already completed steps for this Payrun  ('+this.fiscal_month_name+' - '+this.fiscal_year+') up to '+this.all_steps[step_number-1]+'. Do you want to jump to the Payrun step or do you want to redo all the steps?', {title: 'Confirmation', size: 'md', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Go to the Payrun step', cancelTitle: 'I want to follow all the steps', footerClass: 'p-2', hideHeaderClose: false,centered: true})
                                    .then(value => {                 
                                                        if(value)
                                                        {                        
                                                            this.$refs.wizard.changeTab(0,step_number);
                                                        }else{
                                                            this.resetPayrunProgress(upd_step);
                                                        }
                                                    })
                                                    .catch(err => {
                                                        // An error occurred
                                                        });

                                }
                                else
                                {
                                    this.$bvModal.msgBoxConfirm('Looks like you already completed steps for this PF  ('+this.fiscal_month_name+' - '+this.fiscal_year+') up to '+this.all_steps[step_number-1]+'. Do you want to jump to the PF Run step or do you want to redo all the steps?', {title: 'Confirmation', size: 'md', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Go to the Provident Fund Run step', cancelTitle: 'I want to follow all the steps', footerClass: 'p-2', hideHeaderClose: false,centered: true})
                                    .then(value => {                 
                                                        if(value)
                                                        {                        
                                                            this.$refs.wizard.changeTab(0,step_number);
                                                        }else{
                                                            this.resetPayrunProgress(upd_step);
                                                        }
                                                    })
                                                    .catch(err => {
                                                        // An error occurred
                                                        });

                                }
                                
                            }else{
                              this.$refs.wizard.nextTab();  
                            }
                          }
                        }
                        else
                        this.$refs.wizard.nextTab();
                    }.bind(this));
                }
            }, 
            
            getPayrollStep: function()
            {
               let curr_obj = this;
                axios.get(this.$api_url+'/check-wizard-step' , {
                    params: {
                    }
                }).then(function(response){
                  if(response.data.success){
                    if(response.data.wizard_info){
                       this.componentKey = this.componentKey+1;
                       this.ReceivedfromChild(response.data.wizard_info.fiscal_year,parseInt(response.data.wizard_info.month)+1);
                    }
                    if(response.data.wizard_step){
                       let curr_steps = ['fiscal_year','joiner','contract','leaver','payrun']; 
                       let curr_step = curr_steps.indexOf(response.data.wizard_step);
                       this.$refs.wizard.changeTab(0,curr_step);
                    }
                  }                  
                }.bind(this));
            },
            
        },
        created: function(){
            this.flushEmployee();
            this.getPayrollStep();
            this.getpayruns();    

            if(this.$atl_company_package_title == 'Provident Fund Only')
            {
                this.run_payroll_title = 'Run Provident Fund';
            }
            
            console.log('$atl_company_package_title');
            console.log(this.$atl_company_package_title);

            //this.countPayslip();      
            /*this.getAcl();
            if(this.company_id > 0)
                this.$refs.wizard.activateAll();*/
        }
    }
</script>


<style>
    /*.wizard-btn { display:none ! important }
    .vue-form-wizard.md .wizard-icon-circle {
    	width: 42px;
    	height: 42px;
    	font-size: 29px;
    }*/
</style>